<template>
	<h1>Logging Out..</h1>
</template>
<script>
export default {
	name: 'logout',
	mounted () {
		this.$store
		.dispatch('auth/logout')
		.then(() => {
			this.$router.push('/login');
		})
		.catch(err => {
			console.log(err);
		})
	}
}
</script>
<style>
  @import url(https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.css); 
</style>
